export const font = {
  'family-mono':
    "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace",
  'size-xs': '11px',
  'size-sm': '13px',
  'size-md': '16px',
  'size-lg': '17px',
  'size-xl': '19px',
  'size-h-3xs': '17px',
  'size-h-2xs': '19px',
  'size-h-xs': '20px',
  'size-h-sm': '23px',
  'size-h-md': '27px',
  'size-h-lg': '31px',
  'size-h-xl': '35px',
  'size-h-2xl': '39px',
  'letter-spacing-heading': '-0.01em',
  'letter-spacing-body': '-0.01em',
  'letter-spacing-label': '-0.025em',
  'line-height-xs': '18px',
  'line-height-sm': '20px',
  'line-height-md': '24px',
  'line-height-lg': '28px',
  'line-height-xl': '30px',
  'line-height-h-3xs': '26px',
  'line-height-h-2xs': '28px',
  'line-height-h-xs': '30px',
  'line-height-h-sm': '32px',
  'line-height-h-md': '36px',
  'line-height-h-lg': '40px',
  'line-height-h-xl': '44px',
  'line-height-h-2xl': '52px',
  'family-display': "'Poppins'",
  'family-sans': "'Poppins'",
  url: '//fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700',
}
